var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54864 0.172348L1.18501 5.89962C0.985709 6.05463 0.869141 6.29297 0.869141 6.54545V15.5455C0.869141 16.9011 1.96808 18 3.32369 18H6.59641H11.5055H14.7782C16.1338 18 17.2328 16.9011 17.2328 15.5455V6.54545C17.2328 6.29297 17.1162 6.05463 16.9169 5.89962L9.55327 0.172348C9.25782 -0.0574494 8.8441 -0.0574494 8.54864 0.172348ZM12.3237 16.3636H14.7782C15.2301 16.3636 15.5964 15.9973 15.5964 15.5455V6.94555L9.05096 1.854L2.5055 6.94473V15.5455C2.5055 15.965 2.82136 16.3109 3.22827 16.3581L3.32369 16.3636H5.77823V9C5.77823 8.58041 6.09408 8.23458 6.501 8.18732L6.59641 8.18182H11.5055C11.9251 8.18182 12.2709 8.49767 12.3182 8.90458L12.3237 9V16.3636ZM7.4146 16.3636V9.81818H10.6873V16.3636H7.4146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconWhite);
export default __webpack_public_path__ + "static/media/home-icon-white.ada776dd41bb9a778766d281edfcf1f5.svg";
export { ForwardRef as ReactComponent };